import React from 'react'
import { Link } from "react-scroll";

export default function Hero1() {
  return (
    <section id='inicio' className='hero-section'>
      <div className="min-h-screen bg-hero-pattern">
        <div className="overlay min-h-screen flex items-center justify-center">
          <div className="content-wrapper text-center px-4 md:px-8 py-16">
            <div className="mx-auto" style={{marginTop:'-5rem'}}>
              <div style={{display:'flex', justifyContent:'center',marginBottom:'1rem'}}>
              <img alt="Girl in a jacket" width="500" height="600" src='img/1.webp' />
              </div>
              
              <h1 className="text-2xl md:text-5xl font-bold leading-tight mb-6">
              Herramientas para una agricultura digital
              </h1>
              <div className="div-btn-hero">
              <a style={{fontSize:'1.5rem'}}
                target='_blank' rel="noopener noreferrer"
                href="https://agai.cl/"
                smooth={true}
                duration={500}
                offset={-70}
                className="btn btn-primary w-full md:w-auto cursor-pointer"
              >
                Prueba nuestro Chatbot Agai
              </a>
              <Link style={{fontSize:'1.5rem'}}
                to="contacto"
                smooth={true}
                duration={500}
                offset={-70}
                className="btn btn-contacto w-full md:w-auto cursor-pointer verde"
              >
                Contáctanos
              </Link>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
